import React, { useState } from 'react';
import * as classes from './ServicesSection.module.scss';
import { ServicesSectionProps } from '../../../../../Sections/HomePage/ServicesSection/ServicesSection';
import ServiceSlide from '../../../Components/ServiceSlide/ServiceSlide';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import cn from 'classnames';
import TriangleBlock from '../../../Components/TriangleBlock/TriangleBlock';
import decoratorImage from '../../../../../../assets/images/white-blue-decorator.svg';

SwiperCore.use([Navigation]);

const ServicesSection = ({ services }: ServicesSectionProps) => {
  const [currentSlide, setCurrentSlide] = useState(1);
  return (
    <section className={cn(classes.wrapper, 'swiper-modern-template')} data-aos='fade-in'>
      <Swiper
        slidesPerView={1}
        spaceBetween={0}
        navigation={true}
        className={classes.swiperWrapper}
        autoHeight
        onRealIndexChange={index => setCurrentSlide(index.realIndex + 1)}
      >
        {services.map(item => {
          const specialties = [...item.specialties.map(item => item.title), ...item.customSpecialties];
          const benefits = [...item.helps.map(it => it.title), ...item.customHelps];
          // if (item.sector?.benefits?.length) {
          //   benefits = [...benefits, ...item.sector.benefits];
          // }
          return (
            <SwiperSlide key={item.id}>
              <ServiceSlide
                specialties={specialties}
                helps={benefits}
                name={item?.sector?.title || item.customSector}
                image={item.picture?.url}
                appointmentTypes={item.appointmentTypes.concat(
                  item.customAppointmentTypes.map((item, index) => ({ title: item, id: index.toString() })),
                )}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className={classes.counter}>
        {currentSlide}/{services.length}
      </div>
      <TriangleBlock className={classes.triangle} />
      <img src={decoratorImage} alt='' className={classes.decorator} />
    </section>
  );
};

export default ServicesSection;
